import ResumeTemplate1 from "assets/resumetemplates/resumetemplate1/ResumeTemplate1";
import ResumeTemplate1Image from "assets/resumetemplates/resumetemplate1/resume_template_1.png";

import ResumeTemplate2Image from "assets/resumetemplates/resumetemplate2/resume_template_2.png";
import ResumeTemplate2 from "assets/resumetemplates/resumetemplate2/ResumeTemplate2";

import ResumeTemplate3Image from "assets/resumetemplates/resumetemplate3/resume_template_3.png";
import ResumeTemplate3 from "assets/resumetemplates/resumetemplate3/ResumeTemplate3";

import ResumeTemplate4Image from "assets/resumetemplates/resumetemplate4/resume_template_4.png";
import ResumeTemplate4 from "assets/resumetemplates/resumetemplate4/ResumeTemplate4";

import ResumeTemplate5 from "assets/resumetemplates/resumetemplate5/ResumeTemplate5";
import ResumeTemplate5Image from "assets/resumetemplates/resumetemplate5/resume_template_5.png";

import ResumeTemplate6 from "assets/resumetemplates/resumetemplate6/ResumeTemplate6";
import ResumeTemplate6Image from "assets/resumetemplates/resumetemplate6/resume_template_6.png";

export const resumeTemplateList = [
    {
        name: 'compact_connection',
        image: ResumeTemplate1Image.src,
        template: <ResumeTemplate1 />,
        margin_top: 5,
        margin_bottom: 6,
        title: 'Compact Connection',
        description: 'A streamlined design that connects your credentials and certifications in a modern format.'
    },
    {
        name: 'profile_plus',
        image: ResumeTemplate2Image.src,
        template: <ResumeTemplate2 />,
        margin_top: 8,
        margin_bottom: 6,
        title: 'Profile Plus',
        description: 'A comprehensive resume featuring your photo, skills, and experiences.',

    },
    {
        name: 'essence_of_you',
        image: ResumeTemplate3Image.src,
        template: <ResumeTemplate3 />,
        margin_top: 8,
        margin_bottom: 6,
        title: 'Essence of You',
        description: 'A minimalist layout that highlights your qualifications, keeping it clean and impactful.',
    },
    {
        name: 'pathfinder',
        image: ResumeTemplate4Image.src,
        template: <ResumeTemplate4 />,
        margin_top: 8,
        margin_bottom: 6,
        title: 'Pathfinder',
        description: 'A unique roadmap design that illustrates your educational and career journey effectively.'
    },
    {
        name: 'vibrant_view',
        image: ResumeTemplate5Image.src,
        template: <ResumeTemplate5 />,
        margin_top: 8,
        margin_bottom: 6,
        title: 'Vibrant View',
        description: 'An engaging resume that brings your achievements to life with an energetic layout.'
    },
    {
        name: 'skill_focus',
        image: ResumeTemplate6Image.src,
        template: <ResumeTemplate6 />,
        margin_top: 8,
        margin_bottom: 6,
        title: 'Skill Focus',
        description: 'A dedicated format emphasizing your strengths, with a clear section for your personal story.'
    },
]